var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 527.152,
    height: 242.932,
    viewBox: "0 0 527.152 242.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-696.999 -302.952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-263-34.517v-32.7l81.978-129.151h28.189v45.256h-16.683L-221.2-69.322v1.534h116.5v33.271ZM-168.75,0V-44.489l.767-14.478v-137.4h38.928V0ZM0,4.315q-24.737-.1-42.523-12.177t-27.326-35q-9.54-22.915-9.444-55.131,0-32.12,9.54-54.748t27.326-34.469Q-24.641-199.048,0-199.048t42.427,11.889Q60.213-175.27,69.8-152.69t9.492,54.7q0,32.312-9.54,55.227t-27.278,35Q24.737,4.315,0,4.315ZM0-30.107q16.875,0,26.942-16.971T36.914-97.99q0-22.34-4.554-37.2t-12.848-22.34A28.192,28.192,0,0,0,0-165.011q-16.779,0-26.847,16.779T-37.01-97.99q0,22.628,4.554,37.729t12.9,22.628A28.263,28.263,0,0,0,0-30.107Zm105.852-4.411v-32.7L187.83-196.364h28.189v45.256H199.336l-51.68,81.786v1.534h116.5v33.271ZM200.1,0V-44.489l.767-14.478v-137.4H239.8V0Z",
    transform: "translate(960 502)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10221 -14616.787)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11128 15083)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.315,64.455v75.433a2.12,2.12,0,0,1-2.119,2.119H2.119A2.12,2.12,0,0,1,0,139.888V64.455a2.12,2.12,0,0,1,2.119-2.119H103.2A2.12,2.12,0,0,1,105.315,64.455Z",
    transform: "translate(0 -62.336)",
    fill: "#e8e6ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.315,64.455V75.692H0V64.455a2.12,2.12,0,0,1,2.119-2.119H103.2A2.12,2.12,0,0,1,105.315,64.455Z",
    transform: "translate(0 -62.336)",
    fill: "#9dafce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.19,64.456V75.693h-5.05c.174-5.819.049-10.529-.08-13.356h3.011A2.119,2.119,0,0,1,492.19,64.456Z",
    transform: "translate(-386.875 -62.337)",
    fill: "#8198c1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.873 5.089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.025,90.257H35a1.589,1.589,0,0,1,0-3.178h.024a1.589,1.589,0,1,1,0,3.178Z",
    transform: "translate(-33.412 -87.079)",
    fill: "#8198c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.351,90.257h-.024a1.589,1.589,0,0,1,0-3.178h.024a1.589,1.589,0,0,1,0,3.178Z",
    transform: "translate(-51.94 -87.079)",
    fill: "#8198c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.678,90.257h-.024a1.589,1.589,0,0,1,0-3.178h.024a1.589,1.589,0,0,1,0,3.178Z",
    transform: "translate(-70.469 -87.079)",
    fill: "#8198c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.305,90.257h-2.957a1.589,1.589,0,0,1,0-3.178h2.957a1.589,1.589,0,0,1,0,3.178Z",
    transform: "translate(-363.325 -87.079)",
    fill: "#8198c1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.9af9bef5e5d329d304162d78fdae065a.svg";
export { ForwardRef as ReactComponent };